import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { Col, Grid, Row, styled } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';

import VideoEmbed from '../../components/VideoEmbed/VideoEmbed';

import { withSettings } from '../../containers/WebApp/SettingsContext';
import LoadingAnimation from '_platform/src/components/Loading/LoadingAnimation';
import PrivateComponent from '_platform/src/utils/PrivateComponent';

import LoadAsync from '_platform/src/utils/LoadAsync';

import Banner from 'components/CustomComponents/Banners/Banner';

import BgWhite from 'components/CustomComponents/Backgrounds/BgWhite';

import YeehawHeading from './images/yeehaw-heading.svg';
import IconHat from './images/cowboy-hat-icon.svg';

import HomeBanner from './images/home-banner.jpg';
import HomeBanner2x from './images/home-banner@2x.jpg';

import TitleBg from './images/bg-title.jpg';
import TitleBg2x from './images/bg-title@2x.jpg';

import IconMoney from './images/icon-money.svg';
import IconArrows from './images/icon-arrows.svg';
import IconMountain from './images/icon-mountain.svg';
import IconSun from './images/icon-sun.svg';

const StatementProvider = LoadAsync(() =>
  import(
    /* webpackChunkName: "statementProvider" */ '../StatementProvider/StatementProvider'
  )
);
const StatementIncentiveTiersMini = LoadAsync(() =>
  import(
    /* webpackChunkName: "statementIncentiveTiers" */ '../../components/StatementRecover/StatementIncentiveTiersMini'
  )
);

const VideoContainer = styled.div`
  box-shadow: 0px 10px 25px #00000029;
  margin-bottom: 40px;
`;

const HowToStep = styled(Col)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .howtostep__image {
    display: block;
    width: 100%;
    margin-top: 50px;
    img {
      display: block;
      margin: 0 auto;
    }
  }
  .howtostep__text {
    align-items: center;
    text-align: center;
  }
  h3 {
    font-size: 18px;
    font-weight: 550;
    font-variation-settings: 'wght' 550;
    margin-bottom: 0;
    margin-top: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 1.2rem;
    text-transform: uppercase;
  }
  p {
    font-size: 14px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    line-height: 1.2;
  }
`;

const fetchStatements = [
  {
    endpoint: '/Statement/v1/Incentive',
    section: 'incentive',
  },
  {
    endpoint: '/Statement/v1/Incentive/Tiers',
    section: 'incentiveTiers',
  },
];

const HomePage = ({ settings }) => {
  return (
    <div className="page-container">
      <Helmet>
        {/* <meta name="description" content="Page description" /> */}
      </Helmet>

      <PrivateComponent
        redirectOnError={{
          pathname: settings.settingsApp.loginPagePath || '/login/',
        }}
      >
        {/*<CodesWrapper>
          <Grid>
            <ThemeProvider
              theme={{
                inputPaddingY: `calc(.375rem - 1px)`,
                primary: '#f4bd19',
              }}
            >
              <CodesProvider
                disableMeta
                redeemLabels={{
                  button: 'Add your voucher',
                  input: 'Add more unique vouchers now',
                  placeholder: 'Unique voucher number',
                  successMessage:
                    'Success! Your voucher points have been applied.',
                  errorMessage:
                    "Uh-oh! We've encountered an error trying to apply your voucher. Check the voucher number and try again.",
                }}
                // show="list"
              />
            </ThemeProvider>
          </Grid>
        </CodesWrapper>*/}

        <Banner
          pageTitle={
            <h1>
              <img src={YeehawHeading} alt="Yeehaw to Yellowstone" />
              <span>Distributor incentive program 2025/2026</span>
            </h1>
          }
          bannerDesktop={HomeBanner}
          bannerDesktop2x={HomeBanner2x}
        />
        <Grid>
          <Row justifyContent="center">
            <Col xs={12} md={11}>
              <div className="spacer--top">
                <div className="spacer--bottom">
                  <h2 className="fancy">
                    Yeehaw to yellowstone distributor growth incentive program
                    2025/26
                  </h2>
                </div>
                <VideoContainer>
                  <VideoEmbed
                    videoId="nWxXcIcVqmg"
                    title="Yeehaw to Yellowstone"
                  />
                </VideoContainer>
              </div>
            </Col>
          </Row>
        </Grid>

        <Banner
          pageTitle={
            <h2>
              <span>Earn your</span> cowboy hats
            </h2>
          }
          bannerDesktop={TitleBg}
          bannerDesktop2x={TitleBg2x}
        />

        <BgWhite>
          <Grid>
            <Row justifyContent="center">
              <Col sm={11}>
                <StatementProvider
                  fetch={fetchStatements}
                  render={({ statement, onStatementUpdateTargetRequest }) => {
                    function onTargetUpdate(values) {
                      return onStatementUpdateTargetRequest(
                        values,
                        fetchStatements
                      );
                    }

                    return !statement || !statement.data ? (
                      <LoadingAnimation /> // Loader instead of `null`?
                    ) : (
                      <StatementIncentiveTiersMini
                        statement={statement.data}
                        onStatementUpdateTargetRequest={onTargetUpdate}
                      />
                    );
                  }}
                />
              </Col>
            </Row>
          </Grid>
        </BgWhite>

        <Banner
          pageTitle={
            <h2>
              <span>My Activity</span> Explained
            </h2>
          }
          bannerDesktop={TitleBg}
          bannerDesktop2x={TitleBg2x}
        />

        <Grid p={0}>
          <Row justifyContent="center">
            <Col md={11}>
              <Grid>
                <Row>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconMoney} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>
                        Sales
                        <br />
                        Accurate To
                      </h3>
                      <p>
                        This is the latest week ending date that sales
                        (purchases) have been updated to.
                      </p>
                    </div>
                  </HowToStep>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconHat} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>
                        Cowboy Hats
                        <br />
                        Achieved
                      </h3>
                      <p>
                        This is your total Cowboy Hats earned across all 5
                        Australian Suppliers or 2 New Zealand Suppliers.
                      </p>
                    </div>
                  </HowToStep>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconHat} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>
                        Cowboy Hats
                        <br />
                        Projected
                      </h3>
                      <p>
                        This is your total Cowboy Hats forecast for all 5
                        suppliers for Australia and 2 New Zealand Suppliers,
                        based on the following calculation: Sales to date,
                        divided by the days elapsed in the program, multiplied
                        by the days remaining in the program.
                      </p>
                      <p>
                        *Please note that this projection will vary depending on
                        your purchase patterns.
                      </p>
                    </div>
                  </HowToStep>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconArrows} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>Sales Target, 1st Cowboy Hat</h3>
                      <p>
                        This is your first sales (purchase) target. Achieve this
                        target and you will receive your 1st Cowboy Hat.
                      </p>
                    </div>
                  </HowToStep>
                </Row>
              </Grid>
            </Col>
          </Row>
          <Row justifyContent="center">
            <Col md={11}>
              <Grid>
                <Row>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconMoney} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>
                        Sales
                        <br />
                        To Date
                      </h3>
                      <p>
                        This is your sales value/volume (purchases) for the
                        applicable supplier only.
                      </p>
                    </div>
                  </HowToStep>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconMountain} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>
                        Your Progress
                        <br />
                        Towards
                      </h3>
                      <p>
                        The bar indicates your progress towards your current
                        Cowboy Hat as indicated. It also indicates your sales
                        (purchases) to date towards your next Cowboy Hat and the
                        sales value/volume (purchases) still required.
                      </p>
                    </div>
                  </HowToStep>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconSun} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>
                        Days
                        <br />
                        Remaining
                      </h3>
                      <p>
                        This indicates how many buying days are remaining in the
                        program
                      </p>
                    </div>
                  </HowToStep>
                  <HowToStep xs={12} sm={3}>
                    <div className="howtostep__image">
                      <img src={IconHat} alt="" />
                    </div>
                    <div className="howtostep__text">
                      <h3>
                        Each Additional
                        <br />
                        Cowboy Hat Value
                      </h3>
                      <p>
                        When you achieve the equivalent value in sales
                        (purchases) you will receive 1 additional Cowboy Hat
                        each time.
                      </p>
                      <p>
                        *Note that this is applicable ONLY after you achieve
                        your initial Cowboy Hat.
                      </p>
                    </div>
                  </HowToStep>
                </Row>
              </Grid>
            </Col>
          </Row>
        </Grid>
      </PrivateComponent>
    </div>
  );
};

HomePage.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default withSettings(HomePage);
